import { Box, CircularProgress, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  box: {
    position: 'absolute',
    width: '100%',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))

const BoxPageLoader = () => (
  <Box display="flex" alignItems="center" justifyContent="center" className={useStyles().box}>
    <Box display="inherit" alignItems="inherit">
      <Box mr={2}>
        <CircularProgress title="Bezig met laden" />
      </Box>
      <Typography align="center" variant="h3" component="p" gutterBottom>
        De pagina wordt geladen
      </Typography>
    </Box>
  </Box>
)

export default BoxPageLoader
